import { Badge } from 'reactstrap';
import {
  getBadgeColorVisitPreSaleStatusAdapter,
  getVisitPreSaleStatusAdapter,
} from '../../pages/properties/adapters/visitsAdapter';

interface Props {
  status: string;
  className?: string;
}

const InvestorVisitsBadge = ({ status, className = 'badge-lg' }: Props) => {
  return (
    <Badge
      className={className}
      color={getBadgeColorVisitPreSaleStatusAdapter(status)}
    >
      {getVisitPreSaleStatusAdapter(status)}
    </Badge>
  );
};

export default InvestorVisitsBadge;
